export default __webpack_public_path__ + "static/media/parking-arrow.20e12b45.svg";